module.exports = __webpack_public_path__ + "static/img/defult.94baffe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hongbao/text/defult.png
// module id = ZNsG
// module chunks = 1